import { Component, inject, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IAddress } from 'app/models/address/address';
import { IEntityOwner } from 'app/models/licenses/entity-owner';
import { IInHomeCareChange } from 'app/models/licenses/in-home-care/in-home-care-change';
import { ILicenseChange } from 'app/models/licenses/license-change';
import { InHomeCareChangeService } from 'app/services/license/in-home-care/in-home-care-change.service';

@Component({
  selector: 'app-manage-in-home-care-changes',
  templateUrl: './manage-in-home-care-changes.component.html',
  styleUrls: ['./manage-in-home-care-changes.component.scss']
})
export class ManageInHomeCareChangesComponent {
  @Input() entityId: number = 0;

  public changes: IInHomeCareChange[] = [];
  public change: IInHomeCareChange = {
    newParent: '',
    subunits: [],
    id: 0,
    licenseId: 0,
    licenseGuid: '',
    entity: '',
    type: '',
    originalValue: '',
    newValue: '',
    dateRequested: '',
    requestedBy: '',
    effectiveDateOfChange: '',
    signature: '',
    title: '',
    dateSigned: '',
    requiresPayment: false,
    approved: false,
    denied: false,
    determinationBy: '',
    dateOfDetermination: ''
  }

  public owner:IEntityOwner = {
    id: 0,
    parentId: 0,
    firstName: '',
    lastName: '',
    phone: '',
    fax: '',
    taxId: '',
    contactWithClient: false,
    archived: false
  }

  public address: IAddress = {
    id: 0,
    state: '',
    city: '',
    street: '',
    zip: '',
    county: '',
    archived: false,
    parentId: 0,
    addressTypes: []
  }

  public changeColumns: string [] = ['licenseGuid', 'type', 'entity', 'approved', 'effectiveDate'];
  public changeSource = new MatTableDataSource<ILicenseChange>(this.changes);
  @ViewChild('changePaginator', {static: false}) changePaginator!: MatPaginator;
  @ViewChild('changeSort', {static: false}) changeSort!: MatSort;

  public sharedService = inject(SharedService);
  public changeService = inject(InHomeCareChangeService);

  ngOnChanges(): void {
    this.getChanges();
  }

  getChanges(): void {
    this.changeService.getChanges(this.entityId).subscribe({
      next: response => this.changes = response,
      error: e => console.log('error getting changes', e),
      complete: () => {
        this.updateChangeTable();
      }
    });
  }

  updateChangeTable(): void {
    setTimeout(() => {
      this.changeSource.data = this.changes;
      this.changeSource.sort = this.changeSort;
      this.changeSource.paginator = this.changePaginator;
    }, 500);
  }

  close(): void {
    if(this.change.entity === this.sharedService.entityOwner && this.change.type === this.sharedService.delete){
        this.owner = {
          id: 0,
          parentId: 0,
          firstName: '',
          lastName: '',
          phone: '',
          fax: '',
          taxId: '',
          contactWithClient: false,
          archived: false
        }
    }
    this.change = this.getEmptyChange();
    this.updateChangeTable();
  }

  getEmptyChange(): IInHomeCareChange {
    return {
      newParent: '',
      subunits: [],
      id: 0,
      licenseId: 0,
      licenseGuid: '',
      entity: '',
      type: '',
      originalValue: '',
      newValue: '',
      dateRequested: '',
      requestedBy: '',
      effectiveDateOfChange: '',
      signature: '',
      title: '',
      dateSigned: '',
      requiresPayment: false,
      approved: false,
      denied: false,
      determinationBy: '',
      dateOfDetermination: ''
    };
  }

  selectChange(change: IInHomeCareChange): void {
    if(change.entity === this.sharedService.entityOwner && change.type === this.sharedService.delete){
      this.owner = JSON.parse(change.originalValue ?? '');
    }
    if((change.entity === this.sharedService.branchOperation || change.entity === this.sharedService.address) && change.type === this.sharedService.change){
      this.address = JSON.parse(change.originalValue ?? '');
    }
    this.change = change;
  }

  deleteChange(change: IInHomeCareChange): void {
    if(change.approved || change.denied){
      return;
    }
    this.sharedService.openConfirm('Cancel this change request?');
    this.sharedService.confirmed().subscribe(
      confirmed => {
        if(confirmed){
          this.changeService.deleteChange(change.id).subscribe({
            next: () => {
              this.changes = this.changes.filter(c => c.id !== change.id);
            },
            error: e => console.log('error deleting change', e),
            complete: () => {
              this.close();
              this.updateChangeTable();
            }
          });
        }
      }
    );
  }
}
